/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "890d6ac4d5c1a2fe3f55bbb7454bea812a1797a1";
